export default __webpack_public_path__ + "static/media/spray_paint@3x.7b635b37.png";